import * as types from '@/store/types'
import { throwError } from '@/utils/store'

export default {
  [types.GET_ACCOUNT_SETTINGS]: ({ commit, getters }) => {
    const name = types.ACCOUNT_SETTINGS

    commit(types.LOADING, name)
    return getters.apiService
      .getAccountSettings()
      .then((model) => {
        if (model) {
          commit(types.SET_MODEL, { name, model })
        } else {
          throwError(commit, 'Ошибка: не получен список настроек от сервера')
        }
      })
      .catch(throwError(commit, `Ошибка получения настроек (${name})`))
      .finally(() => commit(types.LOADED, name))
  },

  [types.CHANGE_ACCOUNT_SETTING]: ({ state, commit, getters }, { setting, value }) => {
    const name = types.ACCOUNT_SETTINGS
    const { accountId } = state[types.ACCOUNT_SETTINGS].model

    commit(types.LOADING, name)
    return getters.apiService
      .changeAccountSettings({ setting, accountId, value })
      .then((model) => {
        commit(types.UPDATE_MODEL, { name, model })
      })
      .catch(throwError(commit, `Ошибка сохранения настроек (${setting})`))
      .finally(() => commit(types.LOADED, name))
  },

  [types.SAVE_NOTIFICATION_TOOLS]: ({ commit, getters }, { removed, added }) => {
    const name = types.ACCOUNT_SETTINGS

    commit(types.LOADING, name)
    return getters.apiService
      .saveNotificationTools({ added, removed })
      .then((model) => {
        commit(types.UPDATE_MODEL, { name, model })
      })
      .catch(throwError(commit, 'Ошибка изменения списка способов уведомлений'))
      .finally(() => commit(types.LOADED, name))
  },

  [types.SAVE_MASKS]: ({ commit, getters }, { removed, added }) => {
    const name = types.ACCOUNT_SETTINGS

    commit(types.LOADING, name)
    return getters.apiService
      .saveMasks({ added, removed })
      .then((model) => {
        commit(types.UPDATE_MODEL, { name, model })
      })
      .catch(throwError(commit, 'Ошибка изменения списка бан-масок'))
      .finally(() => commit(types.LOADED, name))
  }
}
